import React, { useState } from "react";
import Tooltip from "@mui/material/Tooltip";
import Button from "@mui/material/Button";

interface ElipsedTextProps {
  text: string;
  maxLength?: number; // Maximum length before text is truncated
  shouldWrap?: boolean; // Whether to wrap the text
  showPreferenceButtons?: boolean;
}

const ElipsedText: React.FC<ElipsedTextProps> = ({
  text,
  maxLength = 25,
  shouldWrap = false,
  showPreferenceButtons = false,
}) => {
  const [isExpanded, setIsExpanded] = useState(!showPreferenceButtons);

  const handleToggle = () => {
    setIsExpanded((prev) => !prev);
  };

  const shouldEllipseSize =
    text?.length > maxLength && (shouldWrap ? !isExpanded : true);
  const displayText = shouldEllipseSize
    ? `${text.slice(0, maxLength)}...`
    : text;

  return (
    <Tooltip
      title={text}
      arrow
      disableHoverListener={!shouldEllipseSize || shouldWrap}
    >
      <span
        className={`tw-text-ellipsis tw-overflow-hidden tw-block tw-max-w-full tw-cursor-default ${shouldWrap ? "tw-whitespace-normal" : "tw-whitespace-nowrap"}`}
        style={{ wordBreak: shouldWrap ? "break-word" : "normal" }}
      >
        {displayText}
        {showPreferenceButtons && shouldWrap && text.length > maxLength && (
          <Button
            size="small"
            className="tw-text-blue-500"
            onClick={handleToggle}
          >
            {isExpanded ? "Show Less" : "Show More"}
          </Button>
        )}
      </span>
    </Tooltip>
  );
};

export default ElipsedText;
